import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { Favorite, FavoriteCategoryEdit } from '@app/shared/classes/favorite';
import { AwisaFoService } from '@app/shared/services/awisa-fo.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { User } from '@app/core/auth/user';

@Component({
  selector: 'app-favorite-category-delete',
  templateUrl: './favorite-category-delete.component.html',
  standalone: false
})
export class FavoriteCategoryDeleteComponent implements AfterViewInit {
  private user: User;
  isSending = false;
  favorite: Favorite;
  category: string;
  private elm: HTMLElement;

  @ViewChild('favoriteCategoryDeleteModal', {static: false}) favoriteCategoryDeleteModal: ElementRef;
  error = false;
  errorMessage: string;
  @Output()
  updateDeleteFavoriteCategory = new EventEmitter();

  constructor(private authenticationService: AuthenticationService,
              private translateService: TranslateService,
              private awisaFoService: AwisaFoService) {
  }

  ngAfterViewInit(): void {
    this.elm = this.favoriteCategoryDeleteModal.nativeElement as HTMLElement;
    this.user = this.authenticationService.getUser();
  }

  deleteFavoriteCategory(category: string) {
    this.isSending = true;
    const daten: FavoriteCategoryEdit = {
      guid: this.user.guid,
      title: null,
      currentTitle: category
    };

    this.awisaFoService.deleteFavoriteCategory(daten)
      .subscribe({
        next: (result) => {
          this.close();
          this.refreshCurrentPage(result);
          this.showSuccessAlert('favorite.categories.deleted');
          this.isSending = false;
        },
        error: error => {
          this.error = true;
          if (error.error === undefined || error.statusText === 'Unknown Error') {
            this.errorMessage = 'global.error';
          } else {
            this.errorMessage = error.error;
          }
          this.isSending = false;
        }
      });
  }

  open(category: string): void {
    this.elm.classList.add('show');
    this.elm.style.width = '100vw';
    this.category = category;
  }

  close() {
    this.elm.classList.remove('show');
    setTimeout(() => {
      this.elm.style.width = '0';
    }, 75);
    this.error = false;
  }

  refreshCurrentPage(favoriteArr: Favorite[]) {
    this.updateDeleteFavoriteCategory.emit(favoriteArr);
  }

  showSuccessAlert(translateString: string) {
    this.translateService.get(translateString)
      .subscribe(
        (result: string) => {
          Swal.fire({
            title: result,
            position: 'center',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000
          });
        });
  }
}
